import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import moment from 'moment';

import { LIVE_ACTIVITY_STATE_OPTIONS, LIVE_MATCH_SORT_OPTIONS } from '../../helpers/url_data_agent_live_matches_helpers';
import SegmentedControl from './SegmentedControl';

import './LiveMatchListControls.scss';

const MIN_CONFIDENCE_OPTIONS = [
  { value: 0, label: 'All' },
  { value: 0.95, label: '≥95' },
  { value: 0.9, label: '≥90' },
  { value: 0.8, label: '≥80' }
];
const TOGGLES = [
  { key: 'preownedOnly', label: 'Pre-owned' },
  { key: 'mismatchOnly', label: 'Brand ≠' }
];

const LiveMatchListControls = ({ mode, controls, onChange }) => {
  if (mode === 'activity') {
    return (
      <div className='live-match-list-controls'>
        <button type='button' className={cn('lmc-toggle', { on: !controls.date })} aria-pressed={!controls.date} onClick={() => onChange({ date: '' })}>
          All dates
        </button>
        <label className='lmc-date'>
          Date checked
          <input type='date' aria-label='Date checked' max={moment().format('YYYY-MM-DD')} value={controls.date || ''} onChange={e => onChange({ date: e.target.value })} />
        </label>
        <select className='lmc-sort' aria-label='Outcome' value={controls.state || 'all'} onChange={e => onChange({ state: e.target.value })}>
          {LIVE_ACTIVITY_STATE_OPTIONS.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <div className='live-match-list-controls'>
      <select className='lmc-sort' aria-label='Sort' value={controls.sort} onChange={e => onChange({ sort: e.target.value })}>
        {LIVE_MATCH_SORT_OPTIONS.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <SegmentedControl label='Minimum confidence' options={MIN_CONFIDENCE_OPTIONS} value={controls.minConfidence} onChange={minConfidence => onChange({ minConfidence })} />
      <input
        type='search'
        className='lmc-domain'
        value={controls.domain}
        placeholder='Retailer'
        aria-label='Filter by domain'
        onChange={e => onChange({ domain: e.target.value })}
      />
      {TOGGLES.map(toggle => (
        <button
          key={toggle.key}
          type='button'
          className={cn('lmc-toggle', { on: controls[toggle.key] })}
          aria-pressed={controls[toggle.key]}
          onClick={() => onChange({ [toggle.key]: !controls[toggle.key] })}
        >
          {toggle.label}
        </button>
      ))}
    </div>
  );
};

LiveMatchListControls.propTypes = {
  mode: PropTypes.oneOf(['queue', 'activity']).isRequired,
  controls: PropTypes.shape({
    sort: PropTypes.string,
    minConfidence: PropTypes.number,
    domain: PropTypes.string,
    preownedOnly: PropTypes.bool,
    mismatchOnly: PropTypes.bool,
    date: PropTypes.string,
    state: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired
};

export default LiveMatchListControls;
